module.exports = __webpack_public_path__ + "static/media/brc-logo.df6a802b.png";